import { render, staticRenderFns } from "./EmailTemplateList.vue?vue&type=template&id=41f28b1a&scoped=true&"
import script from "./EmailTemplateList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateList.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateList.vue?vue&type=style&index=0&id=41f28b1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f28b1a",
  null
  
)

export default component.exports